import { Skeleton } from '@mui/material'

const SkeletonNetwork = () => {
  return <Skeleton sx={{ width: '50px' }} />
}

export default SkeletonNetwork
